if not App.angularApp?
    return

App.angularApp.directive 'mfNSolverMissing', [() ->
    restrict: 'A'
    require: 'ngModel'
    link: ($scope, element, attrs, ctrl) =>

        # Don't add validation at all if the input isn't required
        findInParent = ($scope, key) =>
            if $scope[key]?
                return $scope[key]

            findInParent $scope.parent, key

        # Find the input config
        inputConfig = findInParent $scope, 'inputConfig'
        if not inputConfig
            throw Error("N Solver red validation: Could not find inputConfig in any parent scope for ng-model #{attrs.ngModel}")

        # Exit if not required
        if inputConfig.value.required?.value isnt true
            return



        if element.hasClass 'ui-select-container'
            element = element.find 'a.ui-select-match'

        # There can be 3 cases for ngModel:
        #
        # 1. fieldSurvey.data['input_name']
        # 2. fieldSurvey.data[inputName] // Where inputName == 'input_name'
        # 3. fieldSurvey.data.input_name
        #
        # In all cases, we want to get "input_name" as a string.

        # Cases 1 and 2
        if match = attrs.ngModel.match(/\[([^\]]+)\]$/)
            match = match[1]
            if match = match.match(/^['"](.*)['"]$/)
                # Case 1
                inputName = match[1]
            else
                # Case 2
                inputName = $scope.$parent.inputName
        else
            # Case 3
            if match = attrs.ngModel.match(/\.([^\.]+)$/)
                inputName = match[1]

        if not inputName
            throw Error("N Solver red validation: Could not find input name for ng-model #{attrs.ngModel}")

        fieldSurvey = findInParent $scope, 'fieldSurvey'

        if not fieldSurvey
            throw Error("N Solver red validation: Could not find fieldSurvey in any parent scope for ng-model #{attrs.ngModel}")

        # red validation should only show up when the "Next" button is clicked
        if $scope.service.nextAttempted and not $scope.service.inputComplete inputName, fieldSurvey
            element.addClass 'mfvalidate-invalid'

        $scope.$watchGroup [attrs.ngModel, attrs.mfNSolverMissing, 'service.nextAttempted'], () ->
            if $scope.service.inputComplete inputName, fieldSurvey
                element.removeClass 'mfvalidate-invalid'
            else if $scope.service.nextAttempted
                element.addClass 'mfvalidate-invalid'
]
